/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { changeLanguage } from '../../i18n';

import fetchConfig from '../../Constants/fetch';

const Page = styled.main`
    min-height: 100vh;
    display: grid;
    place-items: center;
    background: #ebeced;
`;
const Card = styled.section`
    width: min(360px, calc(100% - 40px));
    padding: 32px;
    background: white;
    border-radius: 6px;
`;
const Field = styled.input`
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    margin: 8px 0 16px;
    padding: 0 14px;
    border: 1px solid #9b9b9b;
    border-radius: 4px;
    font-size: 16px;
`;
const Button = styled.button`
    width: 100%;
    height: 50px;
    border: 0;
    border-radius: 4px;
    color: white;
    background: #176b53;
    font-size: 16px;
    cursor: pointer;
`;

const PasswordReset = () => {
    const { t } = useTranslation();
    const params = new URLSearchParams(window.location.search);
    const email = params.get('email') || '';
    const token = params.get('token') || '';
    const language = (params.get('language') || 'en').split('-')[0];
    const [valid, setValid] = useState(null);
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        changeLanguage(language);
        axios
            .post(`${fetchConfig.prefix}/auth/password-reset/validate`, { email, token })
            .then(() => setValid(true))
            .catch(() => setValid(false));
    }, [email, token, language]);

    const submit = async event => {
        event.preventDefault();
        if (password.length < 8 || password.length > 72) {
            setError(t('login.login_section.password_reset.password_length'));
            return;
        }
        if (password !== repeatPassword) {
            setError(t('login.login_section.password_reset.password_mismatch'));
            return;
        }
        setLoading(true);
        setError('');
        try {
            await axios.post(`${fetchConfig.prefix}/auth/password-reset/complete`, {
                email,
                token,
                password,
            });
            setSuccess(true);
        } catch (requestError) {
            setError(
                requestError.response?.data?.error ||
                    t('login.login_section.password_reset.email_error'),
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Page>
            <Card>
                {success ? (
                    <>
                        <h1>{t('login.login_section.password_reset.updated_title')}</h1>
                        <p>{t('login.login_section.password_reset.updated_message')}</p>
                        <Button
                            type="button"
                            onClick={() => {
                                window.location.href = '/';
                            }}
                        >
                            {t('login.login_section.password_reset.return_to_login')}
                        </Button>
                    </>
                ) : valid === false ? (
                    <>
                        <h1>{t('login.login_section.password_reset.expired_title')}</h1>
                        <p>{t('login.login_section.password_reset.expired_message')}</p>
                    </>
                ) : (
                    <form onSubmit={submit}>
                        <h1>{t('login.login_section.password_reset.new_password_title')}</h1>
                        <label htmlFor="new-password">
                            {t('login.login_section.user_password')}
                        </label>
                        <Field
                            id="new-password"
                            type="password"
                            value={password}
                            onChange={event => setPassword(event.target.value)}
                            required
                        />
                        <label htmlFor="repeat-password">
                            {t('login.login_section.password_reset.repeat_password')}
                        </label>
                        <Field
                            id="repeat-password"
                            type="password"
                            value={repeatPassword}
                            onChange={event => setRepeatPassword(event.target.value)}
                            required
                        />
                        {error && <p role="alert">{error}</p>}
                        <Button type="submit" disabled={loading || valid === null}>
                            {loading
                                ? t('login.login_section.password_reset.updating')
                                : t('login.login_section.password_reset.update_password')}
                        </Button>
                    </form>
                )}
            </Card>
        </Page>
    );
};

export default PasswordReset;
